import { createSelector } from 'reselect';
import mappings from './columns';

export const combinedColumnsSelector = createSelector(
    state => state.csaDrilldown.columns,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);

export const getCurrentServerFilters = state => (
    state.csaDrilldown.currentServerFilters
);

export const getColumns = state => (
    state.csaDrilldown.columns
);

export const getInitialised = state => (
    state.csaDrilldown.initialised
);

export const getDefaultFilters = state => (
    state.csaDrilldown.defaultFilters
);

export const getFilterDefinitions = state => (
    state.csaDrilldown.filterDefinitions
);

export const getCsas = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'csa');
        if (filter) {
            return filter.value;
        }
    }
    return [];
};

export const getDateFrom = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};
